import classes from './RectangleButtonMain.module.css'

const SyndicRectangleButton = (props) => {
    return(
        <button
            className={classes.sRoundButton}
            type={props.type || "button"}
            onClick={props.onClick}
            disabled={props.disabled}
            style={props.disabled ? { opacity: 0.4, cursor: "not-allowed" } : {}}
            >{props.children}
        </button>
    )
}

export default SyndicRectangleButton;